module.exports = __webpack_public_path__ + "static/BumbaLogo-dda196b0db0bab450d96dc02180dc3b3.png";